import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { getViewportSize, getInitialViewportSize, addResizeCallback, removeResizeCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { GallerySliderPresentation } from './GallerySliderPresentation.js';

var GallerySliderWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(GallerySliderWrapper, _React$Component);

  var _super = _createSuper(GallerySliderWrapper);

  function GallerySliderWrapper(props) {
    var _this;

    _classCallCheck(this, GallerySliderWrapper);

    _this = _super.call(this, props);

    _this.addSwipeEventListeners = function () {
      window.addEventListener("mousemove", _this.onMouseMove);
      window.addEventListener("mouseup", _this.onMouseUp);
      window.addEventListener("touchmove", _this.onMouseMove, {
        passive: false
      });
      window.addEventListener("touchend", _this.onMouseUp);
      window.addEventListener("touchcancel", _this.onMouseUp);
    };

    _this.removeSwipeEventListeners = function () {
      window.removeEventListener("mousemove", _this.onMouseMove);
      window.removeEventListener("mouseup", _this.onMouseUp);
      window.removeEventListener("touchmove", _this.onMouseMove);
      window.removeEventListener("touchend", _this.onMouseUp);
      window.removeEventListener("touchcancel", _this.onMouseUp);
    };

    _this.setPage = function (page, event) {
      if (page >= 0 && page * _this.state.slidesPerPage !== _this.state.currentSlide && page * _this.state.slidesPerPage < React.Children.count(_this.props.children)) {
        _this.setState(function (prevState) {
          return {
            previousSlide: prevState.currentSlide,
            currentSlide: page * prevState.slidesPerPage,
            animation: true
          };
        }, function () {
          return _this.props.onChange(_this.state.currentSlide, event);
        });
      }
    };

    _this.onMouseDown = function (e) {
      _this.addSwipeEventListeners();

      var screenX = _this.getScreenX(e);

      var screenY = _this.getScreenY(e);

      _this.setState({
        mouseDownPositionX: screenX,
        mouseDownPositionY: screenY,
        mouseDownTimestamp: Date.now(),
        animation: false
      });
    };

    _this.onMouseMove = function (e) {
      var screenX = _this.getScreenX(e);

      var screenY = _this.getScreenY(e); // if vertical scroll, abort


      if (_this.state.mouseMovePosition === undefined && Math.abs(_this.state.mouseDownPositionX - screenX) < Math.abs(_this.state.mouseDownPositionY - screenY)) {
        _this.removeSwipeEventListeners();

        _this.setState({
          mouseDownPositionX: undefined,
          mouseDownPositionY: undefined,
          mouseDownTimestamp: undefined,
          mouseMovePosition: undefined,
          animation: true
        });

        return true;
      }

      if (e.cancelable) {
        e.preventDefault();
      }

      if (_this.outerElement) {
        _this.outerElement.style.touchAction = "pan-y pinch-zoom";
        _this.outerElement.style.userSelect = "none";
      }

      _this.setState({
        mouseMovePosition: screenX,
        animation: false
      });

      return false;
    };

    _this.setNextPage = function (e) {
      return _this.setPage(Math.floor(_this.state.currentSlide / _this.state.slidesPerPage + 1), e);
    };

    _this.setPreviousPage = function (e) {
      return _this.setPage(Math.floor(_this.state.currentSlide / _this.state.slidesPerPage - 1), e);
    };

    _this.onMouseUp = function (e) {
      _this.removeSwipeEventListeners();

      if (_this.outerElement) {
        _this.outerElement.style.touchAction = "";
        _this.outerElement.style.userSelect = "";
      }

      var screenX = _this.getScreenX(e);

      var velocity = (_this.state.mouseDownPositionX - screenX) / (Date.now() - _this.state.mouseDownTimestamp);

      var movement = _this.state.mouseDownPositionX - screenX;
      var nextSlide = movement / _this.state.elementWidth;

      if (nextSlide > 0.5 || velocity > 1) {
        _this.setNextPage(e);
      } else if (nextSlide < -0.5 || velocity < -1) {
        _this.setPreviousPage(e);
      }

      _this.setState({
        mouseDownPositionX: undefined,
        mouseDownPositionY: undefined,
        mouseDownTimestamp: undefined,
        mouseMovePosition: undefined,
        animation: true
      });
    };

    _this.getSlidesPerPage = function (viewport) {
      return {
        xl: _this.props.slidesToDisplay,
        lg: _this.props.slidesToDisplay,
        md: _this.props.slidesToDisplay,
        sm: Math.max(_this.props.slidesToDisplay - 1, 1),
        xs: 1
      }[viewport] || 1;
    }; // To determine the width of each Slide, first check the viewport because in different viewport different number
    // of slides will be displayed. Second use the width of displaywindow to divide the number of slides to be displayed
    // and minus the margin of each slide.


    _this.updateSlideWidth = function () {
      var _a;

      _this.setState({
        slidesPerPage: _this.getSlidesPerPage(getViewportSize()),
        elementWidth: ((_a = _this.someInnerElement) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0,
        animation: false
      });
    };

    _this.state = {
      currentSlide: _this.props.initialSlide || 0,
      previousSlide: 0,
      slidesPerPage: _this.getSlidesPerPage(getInitialViewportSize()),
      elementWidth: 0,
      animation: false,
      mouseDownPositionX: undefined,
      mouseDownPositionY: undefined,
      mouseDownTimestamp: undefined,
      mouseMovePosition: undefined
    };
    return _this;
  }

  _createClass(GallerySliderWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addResizeCallback(this.updateSlideWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeResizeCallback(this.updateSlideWidth);
      this.removeSwipeEventListeners();
    }
  }, {
    key: "getScreenX",
    value: function getScreenX(e) {
      return e.screenX || e.changedTouches[0].screenX;
    }
  }, {
    key: "getScreenY",
    value: function getScreenY(e) {
      return e.screenY || e.changedTouches[0].screenY;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          currentSlide = _this$state.currentSlide,
          previousSlide = _this$state.previousSlide,
          slidesPerPage = _this$state.slidesPerPage,
          animation = _this$state.animation,
          mouseDownPositionX = _this$state.mouseDownPositionX,
          mouseDownPositionY = _this$state.mouseDownPositionY,
          mouseDownTimestamp = _this$state.mouseDownTimestamp,
          mouseMovePosition = _this$state.mouseMovePosition; // offset for centering 2nd and succeeding pages

      var offset = 0;

      if (this.outerElement && this.someInnerElement && getViewportSize() === "xs" && currentSlide > 0) {
        offset = 100 * (1 - this.someInnerElement.offsetWidth / this.outerElement.offsetWidth) / 2;
      }

      var translate = "".concat(100 * currentSlide - offset, "%");
      var children = this.props.children;
      var animationDirection = previousSlide < currentSlide ? 1 : -1;
      var animationOffset = 5 - animationDirection * previousSlide;
      var slides = React.Children.count(children);
      var dotCount = slidesPerPage !== 0 ? Math.ceil(slides / slidesPerPage) : 0;
      var activeDot = Math.floor(currentSlide / slidesPerPage);
      return /*#__PURE__*/React.createElement(GallerySliderPresentation, Object.assign({}, this.props, {
        someElementRef: function someElementRef(r) {
          return _this2.someInnerElement = r;
        },
        outerRef: function outerRef(r) {
          return _this2.outerElement = r;
        },
        currentSlide: currentSlide,
        animation: animation,
        mouseDownPositionX: mouseDownPositionX,
        mouseDownPositionY: mouseDownPositionY,
        mouseDownTimestamp: mouseDownTimestamp,
        mouseMovePosition: mouseMovePosition,
        onMouseDown: function onMouseDown(e) {
          return _this2.onMouseDown(e);
        },
        onDragStart: function onDragStart(e) {
          return e.preventDefault();
        },
        handleArrowRightClick: function handleArrowRightClick(e) {
          return _this2.setNextPage(e);
        },
        handleArrowLeftClick: function handleArrowLeftClick(e) {
          return _this2.setPreviousPage(e);
        },
        handlePointClick: this.setPage,
        dotCount: dotCount,
        activeDot: activeDot,
        translate: translate,
        animationOffset: animationOffset,
        animationDirection: animationDirection
      }));
    }
  }]);

  return GallerySliderWrapper;
}(React.Component);

GallerySliderWrapper.defaultProps = {
  initialSlide: 0,
  titleSize: "h2",
  size: 1,
  slidesToDisplay: 3,
  onChange: function onChange() {
    /* empty */
  }
};

export { GallerySliderWrapper };
